/* src/app/contact/contact.component.css */
.navyCashHeading {
  font-family: Open Sans;
  font-weight: bold;
  font-size: 18pt;
  color: #3b74b0;
}
/*# sourceMappingURL=contact.component.css.map */
